import React, { useContext, useState } from 'react';
import {
	Analysis,
	CardWrapper,
	ContentWrapper,
	ExploreButton,
	Heading,
	IconWrapper,
	RiskWrapper,
	SubWrapper,
	TooltipContent,
	Wrapper,
} from './Cards.styles';
import { ApIcon, ApLoaderDefault } from '@alixpartners/ui-components';
import { InsightsType } from 'CategoryManagement/utils';
import { CategoryRevenueBenchmarkContext } from 'contexts/CategoryRevenueBenchmark';
import { cardColorDefault, iconColor } from './utils';
import RevenueWithinBenchmarkExplore from 'CategoryManagement/Explore/DetailedAnalysis/RevenueWithinBenchmarkExplore';
import ExploreModal from 'CategoryManagement/Explore/ExploreModal';
import { Tooltip } from 'react-tippy';

const CategoryRevenueWithinBenchmark = ({ name }) => {
	const { isFetching: isLoading, analysisWithinRevenue, gridData } = useContext(
		CategoryRevenueBenchmarkContext
	);
	const [isExplore, setIsExplore] = useState(false);

	return (
		<>
			<Wrapper>
				<SubWrapper>
					<RiskWrapper tileColor={cardColorDefault} />
					<CardWrapper>
						<IconWrapper iconColor={iconColor}>
							<div>
								<ApIcon
									material={true}
									iconName={InsightsType[1].iconName}
									iconSize={20}
								/>
							</div>
							<div>
								<Tooltip
									className="help_tooltip"
									position="top-end"
									animation="fade"
									arrow
									html={
										<TooltipContent>
											{`Use Input Client Revenue option in Analysis -> Benchmarks to apply Year & Revenue filter.`}
										</TooltipContent>
									}
									trigger="mouseenter"
								>
									<ApIcon material={true} iconName="help" iconSize={20} />
								</Tooltip>
							</div>
							<div>
								{!isLoading &&
									gridData.rowData.length > 0 && (
										<ExploreButton
											title="Explore"
											className="explore"
											onClick={() => setIsExplore(true)}
										>
											<ApIcon
												title="Explore"
												material={true}
												iconName="find_in_page"
											/>
										</ExploreButton>
									)}
							</div>
						</IconWrapper>
						{isLoading ? (
							<ApLoaderDefault />
						) : (
							<ContentWrapper>
								<Heading>{name}</Heading>
								<Analysis>{analysisWithinRevenue}</Analysis>
							</ContentWrapper>
						)}
					</CardWrapper>
				</SubWrapper>
			</Wrapper>
			{isExplore && (
				<ExploreModal title={name} onClose={setIsExplore}>
					<RevenueWithinBenchmarkExplore />
				</ExploreModal>
			)}
		</>
	);
};

export default CategoryRevenueWithinBenchmark;
